"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var msgpack = require("msgpack-lite");
function encode(x) {
    return msgpack.encode(x);
}
exports.encode = encode;
function decode(buffer) {
    return msgpack.decode(buffer);
}
exports.decode = decode;
//# sourceMappingURL=json.js.map


//////////////////
// WEBPACK FOOTER
// ./local_modules/common/infra/json.js
// module id = 449
// module chunks = 0